module.exports = __webpack_public_path__ + "static/media/profile.b6db2f2c.jpg";